import React, { useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Download, ShieldCheck } from "@phosphor-icons/react";

/** Compact RGPD panel — Article 20 right to data portability. */
export default function RgpdPanel() {
  const [busy, setBusy] = useState(false);

  const downloadExport = async () => {
    setBusy(true);
    try {
      const res = await api.get("/dashboard/rgpd/export", { responseType: "blob" });
      const blob = new Blob([res.data], { type: "application/json" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      const today = new Date().toISOString().slice(0, 10);
      a.download = `moncommerce68-rgpd-export-${today}.json`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
      toast.success("Export RGPD téléchargé.");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Erreur lors de l'export");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="bg-card border border-border rounded-sm p-6 mt-8" data-testid="rgpd-panel">
      <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-4">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-2">
            <ShieldCheck size={18} className="text-primary" weight="duotone"/>
            <div className="label-uppercase">Mes données — RGPD</div>
          </div>
          <h3 className="font-display text-lg font-medium mb-1">Télécharger mes données personnelles</h3>
          <p className="text-sm text-muted-foreground leading-relaxed max-w-xl">
            Article 20 du RGPD — droit à la portabilité. Téléchargez en un clic <b>toutes</b> les données que nous détenons à votre sujet : compte, fiches détenues, avis, demandes de contact reçues, statistiques, abonnements et historique des emails reçus de notre part. Format JSON lisible, exploitable par tout autre service.
          </p>
        </div>
        <button
          onClick={downloadExport}
          disabled={busy}
          className="bg-primary text-primary-foreground hover:bg-[#0f3d29] hover:text-white px-5 py-2.5 rounded-sm font-semibold text-sm flex items-center gap-2 disabled:opacity-60 whitespace-nowrap shrink-0"
          data-testid="rgpd-export-btn"
        >
          <Download size={16} weight="bold"/> {busy ? "Préparation…" : "Télécharger mes données"}
        </button>
      </div>
      <div className="text-[11px] text-muted-foreground mt-4 leading-snug">
        Pour exercer votre droit à l'effacement (Article 17 RGPD), contactez{" "}
        <a href="mailto:moncommerce68@gmail.com" className="text-primary underline">moncommerce68@gmail.com</a>.
      </div>
    </div>
  );
}
